export default __webpack_public_path__ + "scripts/resource/f8753fae6bb3dfa45631635411b6f441.svg";